
import getEnv from '../hytools/getEnv';
import CONFIG from '@/config';
const finderConfig = {
    app_id: CONFIG.finderAppId,
    channel_domain: 'https://finder-snssdk.yaduo.com', // 设置私有化部署数据上送地址，参考2.2节获取
    spa: true,
    log: false, // true:开启日志，false:关闭日志
    autotrack: true, // 全埋点开关，true开启，false关闭
    Native: true,
};
function initByEnv(finderConfig) {
    window.collectEvent('init', finderConfig);
    window.collectEvent('config', {
        evtParams: {
            app_channel: 'Atour_H5', // 设定自定义公共属性
        },
        member_type_name: '',
    });
    window.collectEvent('start');
}

export function initFinder() {
    getEnv().then(env => {
        finderConfig.Native = env.envName === 'app';
        initByEnv(finderConfig);
    }).catch(() => {
        initByEnv(finderConfig);
    });
}

export function setFinderConfig(config) {
    if (window.collectEvent) {
        window.collectEvent('config', config);
    }
}

export function setUserUniqueId(mebId) {
    if (window.collectEvent) {
        window.collectEvent('config', {
            user_unique_id: mebId,
        });
    }
}

export function setMemberTypeName(type) {
    if (window.collectEvent) {
        window.collectEvent('config', {
            member_type_name: type,
        });
    }
}

export function loginRegisterCk(params) {
    window.collectEvent('Login_register_click', params);
}

export function finderPV(eventName, params) {
    window.collectEvent(eventName, {
        page_title: '',
        page_key: 0,
        ...params,
    });
}

export function finderCV(eventName, params) {
    console.log('finder');
    window.collectEvent(eventName, {
        page_title: '',
        page_key: 0,
        element_id: 0,
        element_title: '',
        element_type: '',
        ...params,
    });
}

export function finderEvent(eventName, params) {
    window.collectEvent(eventName, {
        url: window.location.href,
        ...params,
    });
}

